import Cookie from 'cookie-universal'
import {logger} from '@cred/fe-logger'
import config from 'config'
import events from './events'
import {activateExperimentContext} from './utils'

let expiration = new Date(),
  historyOnChange = null

expiration.setMilliseconds(expiration.getMilliseconds() + 365 * 864e+5)

const cookieOptions = {
    expires: expiration,
    secure: config.env !== 'development',
    path: '/',
    httpOnly: false
  },
  eventMap = {}

Object.keys(events).forEach(key => {
  eventMap[events[key].getSchema()] = events[key]
})

/*eslint-disable */
const
/* eslint-enable */
  _setUserId = () => {
    // Get user's UUID from cookies and set it to Snowplow
    const
      cookies = Cookie(),
      uuid = cookies.get('user_id', cookieOptions)

    window.snowplow('setUserId', uuid)
    console.log('Snowplow setting user id', uuid)
  },

  /**
   * @param history (optional)
   */
  initialize = history => {
    if (!global.window) {
      return false
    }

    const collectorUrl = config.env === 'production' ? 'analytics.credible.com' : 'analytics-qa.credible.com',
      jsUrl = '//d1fc8wv8zag5ca.cloudfront.net/2.10.0/sp.js'

    try {
      // Snowplow starts plowing
      (function(p, l, o, w, i, n, g) {
        if (!p[i]) {
          p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
          p.GlobalSnowplowNamespace.push(i);p[i] = function() {
            (p[i].q = p[i].q || []).push(arguments)
          };p[i].q = p[i].q || [];n = l.createElement(o);g = l.getElementsByTagName(o)[0];n.async = 1
          n.src = w;g.parentNode.insertBefore(n, g)
        }
      }(window, document, 'script', jsUrl, 'snowplow'))

      window.snowplow('newTracker', 'default', config.snowplowEndpoint || collectorUrl, {
        appId: config.snowplowAppId,
        platform: 'web',
        encodeBase64: config.snowplowEncodeBase64,
        cookieDomain: '.credible.com',
        contexts: {
          webPage: true,
          performanceTiming: true,
          gaCookies: true
        },
        post: true
      })

      // Enable page pings
      // First ping after 30 seconds, then every 10 seconds
      window.snowplow('enableActivityTracking', 30, 10)

      // ===============================================================================================================
      // Activate experiments context on each URL change event
      // ===============================================================================================================
      // This option is disabled in version #1.3.0 since it requires Experiments Service to be already activated.
      // In order to start using the feature Credimizely should be connected to entire app as a Provider (not a HOC).
      // This change will allow to track URL change event inside Credimizely and activate experiments just before
      // Re-activating Snowplow's global context.
      // ===============================================================================================================
      if (history && history.listen) {
        let prevLocation = Object.assign({}, history.location)

        // Activate global context on page initial load
        activateExperimentContext()

        // Allow this listener in browser only
        historyOnChange = history.listen(newLocation => {
          if (newLocation.pathname !== prevLocation.pathname) {
            activateExperimentContext()
            prevLocation = Object.assign({}, newLocation)
          }
        })

        window.addEventListener('unload', event => {
          if (historyOnChange) {
            historyOnChange()
          }
        })
      }

      console.log('Snowplow initialized for ', config.snowplowAppId)
    } catch (e) {
      console.log('Snowplow initializing error: ', e)
    }
  },

  trackEvent = options => {
    if (!options || !options.event || !global.window) {
      return
    }

    const {event, action, contexts} = options,
      snowplowEvent = eventMap[event.schema]

    if (snowplowEvent) {
      window.snowplow('trackSelfDescribingEvent', snowplowEvent.build(event, action), contexts)
    } else if (event.schema) {
      window.snowplow('trackSelfDescribingEvent', event, contexts)
    }
  },

  trackPageView = (pageTitle, contexts, options) => {
    if (!global.window) {
      return
    }

    _setUserId()

    try {
      let pageUrl = window.location.pathname

      /*
        Activate global context on page initial load. Once added it will be passed to all other tracking events on current page.

        Since this is pulling experiments from the cookies, we want to forego this on partners-widgets since we will be setting the
        global experiment context a different way once experiments have initialized.
      */
      if (options && options.shouldActivateExperimentContext) {
        activateExperimentContext()
      }

      if (options && options.pageUrl) {
        window.snowplow('setCustomUrl', options.pageUrl)
        options.referrerUrl && window.snowplow('setReferrerUrl', options.referrerUrl)
        pageUrl = options.pageUrl
      }

      window.snowplow('trackPageView', pageTitle || null, contexts || null)

      const contextsWithoutSchema = contexts.reduce((acc, context) => {
        const { schema, ...rest } = context
        return [...acc, rest]
      }, [])

      logger.info('pageview', {
        pageUrl,
        pageTitle,
        contexts: contextsWithoutSchema,
      }, `Snowplow pageview: ${pageUrl} ${pageTitle ? pageTitle : ''}`)
    } catch (e) {
      console.log('Snowplow track page view error: ', e)
    }
  }

export {
  initialize,
  trackEvent,
  trackPageView
}

export default {
  initialize,
  trackEvent,
  trackPageView
}
